export const validationSchema: any = {
  email: {
    type: "email",
    required: true,
    properties: {
      empty: "Please enter email",
      email: "Please enter a valid Email",
    },
  },

  staff_email: {
    type: "email",
    properties: {
      email: "Please enter a valid Email",
    },
  },

  clientId: {
    type: "string",
    required: true,
    properties: {
      empty: "Please enter client ID",
    },
  },

  apiKey:{
    type:"string",
    required:true,
    properties:{
      empty:"Please enter API Key"
    }
  },

  secretKey:{
    type:"string",
    required:true,
    properties:{
      empty:"Please enter Secret Key"
    }
  },

  source_id: {
    type: "string",
    required: true,
    properties: {
      empty: "Please enter source ID",
    },
  },

  job_name: {
    type: "string",
    required: true,
    properties: {
      empty: "Please enter job Name",
    },
  },

  rating_title: {
    type: "string",
    required: true,
    properties: {
      empty: "Please enter rating title",
    },
  },

  obtained_from: {
    type: "string",
    required: true,
    properties: {
      empty: "Please enter obtained from",
    },
  },

  status: {
    type: "string",
    required: true,
    properties: {
      empty: "Please enter status",
    },
  },

  minimum_profit_level: {
    type: "string",
    required: true,
    properties: {
      empty: "Please enter minimum profit level",
    },
  },

  minimum_profit_level_message: {
    type: "string",
    required: true,
    properties: {
      empty: "Please enter minimum profit level message",
    },
  },

  clientSecret: {
    type: "string",
    required: true,
    properties: {
      empty: "Please enter client secret",
    },
  },

  customerStrategy: {
    type: "string",
    required: true,
    properties: {
      empty: "Please select customer strategy",
    },
  },

  // deposit invoice fields
  deposit_amount: {
    type: "number",
    required: true,
    properties: {
      empty: "Please enter deposit amount",
      min: {
        limit: 0,
        msg: "Deposit amount must be positive",
      },
    },
  },

  due_date: {
    type: "string",
    required: true,
    properties: {
      empty: "Please enter due date",
    },
  },

  created_at: {
    type: "string",
    required: true,
    properties: {
      empty: "Please enter created at date",
    },
  },

  method: {
    type: "string",
    required: true,
    properties: {
      empty: "Please enter payment method",
    },
  },
  //end deposit invoice fields
  companyName: {
    type: "string",
    required: true,
    properties: {
      empty: "Please enter company name",
    },
  },

  document_name: {
    type: "string",
    required: true,
    properties: {
      empty: "Please enter document name",
    },
  },

  vehicle_type: {
    type: "string",
    required: true,
    properties: {
      empty: "Please select/enter type",
    },
  },

  document_type: {
    type: "string",
    required: true,
    properties: {
      empty: "Please select document type",
    },
  },

  contactName: {
    type: "string",
  },

  emailContact: {
    type: "email",
    properties: {
      email: "Please enter a valid Email",
    },
  },
  otp: {
    type: "string",
    required: true,
    properties: {
      empty: "Please enter OTP",
    },
  },
  referrerId: {
    type: "string",
    required: true,
    properties: {
      empty: "Please select referrer",
    },
  },

  lead_stage: {
    type: "string",
    required: true,
    properties: {
      empty: "Please select lead stage",
    },
  },

  signature: {
    type: "string",
    // required: true,
    properties: {
      dependent: {
        key: "signature_option",
        value: "custom_signature",
        msg: "Please enter signature name",
      },
    },
  },
  signature_option: {
    type: "string",
    required: true,
    properties: {
      empty: "Please enter signature option",
    },
  },

  toMail: {
    type: "email",
    required: true,
    properties: {
      empty: "Please enter email",
      email: "Please enter a valid Email",
    },
  },

  notificationEmail: {
    type: "email",
    properties: {
      email: "Please enter a valid Email",
    },
  },

  emailSignature: {
    type: "string",
  },

  emailDisclaimer: {
    type: "string",
  },
  password: {
    type: "string",
    required: true,
    properties: {
      empty: "Please enter password",
    },
  },

  previousPassword: {
    type: "string",
    required: true,
    properties: {
      empty: "Please enter password",
      minLength: {
        limit: 8,
        msg: "password must be 8 digits",
      },
    },
  },

  verificationCode: {
    type: "string",
    required: true,
    properties: {
      empty: "Please enter verificationCode",
    },
  },

  newPassword: {
    type: "string",
    required: true,
    properties: {
      empty: "Please enter password",
      minLength: {
        limit: 8,
        msg: "password must be 8 digits",
      },
    },
  },

  proposedPassword: {
    type: "string",
    required: true,
    properties: {
      empty: "Please enter password",
      // minLength: {
      //   limit: 8,
      //   msg: "password must be 8 digits",
      // },
    },
  },

  confirmPassword: {
    type: "string",
    required: true,
    properties: {
      empty: "Please enter password",
      minLength: {
        limit: 8,
        msg: "password must be 8 digits",
      },
      match: "New and confirm password must match",
    },
  },

  usernameOrEmail: {
    type: "string",
    required: true,
    properties: {
      empty: "Please enter user name",
    },
  },
  clientName: {
    type: "string",
    required: true,
    properties: {
      empty: "Please enter client name",
    },
  },
  movingToPostcode: {
    type: "string",
    required: true,
    properties: {
      empty: "Please enter moving to postcode",
    },
  },

  payment_type: {
    type: "string",
    required: true,
    properties: {
      empty: "Please select payment type",
    },
  },

  payment_method: {
    type: "string",
    required: true,
    properties: {
      empty: "Please select payment method",
    },
  },

  start_date: {
    type: "string",
    required: true,
    properties: {
      empty: "Please enter start date",
    },
  },
  pay_date: {
    type: "string",
    required: true,
    properties: {
      empty: "Please select payment date",
    },
  },

  amount: {
    type: "string",
    required: true,
    properties: {
      empty: "Please enter amount",
    },
  },

  driver_wage: {
    type: "string",
    required: true,
    properties: {
      empty: "Please enter driver wage",
    },
  },

  porter_wage: {
    type: "string",
    required: true,
    properties: {
      empty: "Please enter porter wage",
    },
  },

  packer_wage: {
    type: "string",
    required: true,
    properties: {
      empty: "Please enter packer wage",
    },
  },

  contents_value: {
    type: "string",
    required: true,
    properties: {
      empty: "Please enter contents value",
    },
  },

  summaryStatus: {
    type: "string",
    required: true,
    properties: {
      empty: "Please select summary status",
    },
  },
  movingFromPostcode: {
    type: "string",
    required: true,
    properties: {
      empty: "Please enter moving from postcode",
    },
  },

  movingToStreet: {
    type: "string",
    required: true,
    properties: {
      empty: "Please enter moving to street",
    },
  },

  movingFromTown: {
    type: "string",
    required: true,
    properties: {
      empty: "Please enter moving from street",
    },
  },

  movingFromStreet: {
    type: "string",
    required: true,
    properties: {
      empty: "Please enter moving from street",
    },
  },

  street: {
    type: "string",
    required: true,
    properties: {
      empty: "Please enter moving from street",
    },
  },
  town: {
    type: "string",
    required: true,
    properties: {
      empty: "Please enter moving from street",
    },
  },

  postcode: {
    type: "string",
    required: true,
    properties: {
      empty: "Please enter moving from postcode",
    },
  },

  movingToTown: {
    type: "string",
    required: true,
    properties: {
      empty: "Please enter moving from street",
    },
  },
  movingToPurchaseStatus: {
    type: "string",
  },
  movingFromPurchaseStatus: {
    type: "string",
  },
  movingFromCounty: {
    type: "string",
  },
  movingToCounty: {
    type: "string",
  },

  movingFromPaces: {
    type: "string",
  },
  movingToPaces: {
    type: "string",
  },
  movingFromFlightOfStairs: {
    type: "string",
  },
  movingToFlightOfStairs: {
    type: "string",
  },
  movingFromBedrooms: {
    type: "string",
  },
  movingToBedrooms: {
    type: "string",
  },
  movingFromFloors: {
    type: "string",
  },
  movingToFloors: {
    type: "string",
  },

  notes: {
    type: "string",
  },
  note: {
    type: "string",
  },
  removalDate: {
    type: "string",
    required: true,
    properties: {
      empty: "Please enter removal date",
    },
  },

  name: {
    type: "string",
    required: true,
    properties: {
      empty: "Please enter name",
    },
  },

  collectFrom: {
    type: "string",
    required: true,
    properties: {
      empty: "Please enter collection from",
    },
  },

  deliverTo: {
    type: "string",
    required: true,
    properties: {
      empty: "Please enter delivery to",
    },
  },

  movingDate: {
    type: "string",
    required: true,
    properties: {
      empty: "Please enter moving date",
    },
  },

  packingDate: {
    type: "string",
    required: true,
    properties: {
      empty: "Please enter packing date",
    },
  },

  customerNotes: {
    type: "string",
    properties: {
      alphanumeric: "Please enter alphanumeric value only",
    },
  },

  customerName: {
    type: "string",
    required: true,
    properties: {
      empty: "Please enter customer name",
    },
  },

  customer_name: {
    type: "string",
    required: true,
    properties: {
      empty: "Please enter customer name",
    },
  },

  followUpDate: {
    type: "string",
  },
  movingOnDate: {
    type: "string",
  },
  packingOnDate: {
    type: "string",
  },

  comments: {
    type: "string",
    properties: {
      alphanumeric: "Please enter comments",
    },
  },

  isAcceptLiabilityCover: {
    type: "boolean",
  },

  liabilityCover: {
    type: "string",
  },
  termLink: {
    type: "string",
  },
  isTerm: {
    type: "boolean",
  },
  isAccept: {
    type: "boolean",
  },
  isSubmitted: {
    type: "boolean",
  },
  thankYouMessage: {
    type: "string",
  },

  details: {
    type: "string",
  },

  collectionAddress: {
    type: "string",
    properties: {
      alphanumeric: "Please enter alphanumeric value only",
    },
  },

  building_number: {
    type: "string",
    properties: {
      alphanumeric: "Please enter alphanumeric value only",
    },
  },

  collectionCity: {
    type: "string",
  },

  county: {
    type: "string",
  },

  country: {
    type: "string",
  },

  collectionPurchaseStatus: {
    type: "string",
  },

  collectionPostcode: {
    type: "string",
    properties: {
      alphanumeric: "Please enter alphanumeric value only",
    },
  },

  collectionVolume: {
    type: "string",
  },

  collectionVolumeUnit: {
    type: "string",
  },

  collectionDistance: {
    type: "string",
  },

  collectionHouseSize: {
    type: "string",
    properties: {
      alphanumeric: "Please enter alphanumeric value only",
    },
  },

  deliveryAddress: {
    type: "string",
    properties: {
      alphanumeric: "Please enter alphanumeric value only",
    },
  },
  deliveryCity: {
    type: "string",
  },
  deliveryPostcode: {
    type: "string",
    properties: {
      alphanumeric: "Please enter alphanumeric value only",
    },
  },

  deliveryVolume: {
    type: "string",
  },

  deliveryVolumeUnit: {
    type: "string",
  },

  deliveryDistance: {
    type: "string",
  },

  deliveryPurchaseStatus: {
    type: "string",
  },

  deliveryHouseSize: {
    type: "string",
    properties: {
      alphanumeric: "Please enter alphanumeric value only",
    },
  },

  username: {
    type: "string",
    required: true,
    properties: {
      empty: "Please enter username",
      noLeadingSpace: "Name cannot start with a space",
      atLeastOneAlpha: "At least one alphabet character is required",
      minLength: {
        limit: 6,
        msg: "Username must be exactly 6 characters long.",
      },
      // maxLength: { limit: 6, msg: "Username must be exactly 6 characters long." },
      // uppercase: "Username must contain at least one uppercase letter.",
      // specialCharacter: "Username must contain at least one special character.",
      // alphanumeric: "Username must be alphanumeric.",
    },
  },

  number: {
    type: "string",
    required: true,
    properties: {
      empty: "Please enter number",
      // number: {
      //   msg: "Phone number must be a number",
      // },
      // maxLength: {
      //   limit: 11,
      //   msg: "Phone number must be 11 digits",
      // },
      // minLength: {
      //   limit: 10,
      //   msg: "Phone number must be 11 digits",
      // },
    },
  },

  to: {
    type: "string",
    required: true,
    properties: {
      empty: "Please enter number",
      number: {
        msg: "Phone number must be a number",
      },
      maxLength: {
        limit: 11,
        msg: "Phone number must be 11 digits",
      },
      minLength: {
        limit: 10,
        msg: "Phone number must be 11 digits",
      },
    },
  },

  message: {
    type: "string",
    required: true,
    properties: {
      empty: "Please enter message",
    },
  },

  template_name: {
    type: "string",
    required: true,
    properties: {
      empty: "Please enter template name",
    },
  },

  subject: {
    type: "string",
    required: true,
    properties: {
      empty: "Please enter subject",
    },
  },

  body: {
    type: "string",
    required: true,
    properties: {
      empty: "Please enter body",
    },
  },

  htmlBody: {
    type: "string",
    required: true,
    properties: {
      empty: "Please enter body",
    },
  },

  title: {
    type: "string",
    required: true,
    properties: {
      empty: "Please enter title",
    },
  },

  location: {
    type: "string",
    required: true,
    properties: {
      empty: "Please enter location",
    },
  },

  surveyType: {
    type: "string",
    required: true,
    properties: {
      empty: "Please select survey type",
    },
  },
  surveyorId: {
    type: "string",
    required: true,
    properties: {
      empty: "Please select survoyer",
    },
  },

  startTime: {
    type: "string",
    required: true,
    properties: {
      empty: "Please enter correct time",
      noPastDate: "Start time cannot be in the past",
      sameAsEnd: "Start time and End time cannot be the same",
      afterEnd: "Start time cannot be greater than end time",
    },
  },

  endTime: {
    type: "string",
    required: true,
    properties: {
      empty: "Please enter correct time",
      noPastDate: "End time cannot be in the past",
      sameAsStart: "End time and Start time cannot be the same",
      afterStartTime: "End time cannot be less than start time",
    },
  },
  eventType: {
    type: "string",
    required: true,
    properties: {
      empty: "Please enter event type",
    },
  },
  startDate: {
    type: "string",
    required: true,
    properties: {
      empty: "Please enter correct time",
      noPastDate: "Start time cannot be in the past",
      sameAsEnd: "Start time and End time cannot be the same",
      afterEnd: "Start time cannot be greater than end time",
    },
  },

  endDate: {
    type: "string",
    required: true,
    properties: {
      empty: "Please enter correct time",
      noPastDate: "End time cannot be in the past",
      sameAsStart: "End time and Start time cannot be the same",
      afterStartTime: "End time cannot be less than start time",
    },
  },

  start_time: {
    type: "string",
    required: true,
    dependentField: "date",
    properties: {
      empty: "Please enter correct time",
      noPastTime: "Start time cannot be in the past",
      sameAsEnd: "Start time and End time cannot be the same",
      afterEnd: "Start time cannot be greater than end time",
    },
  },

  end_time: {
    type: "string",
    required: true,
    dependentField: "date",
    properties: {
      empty: "Please enter correct time",
      noPastTime: "End time cannot be in the past",
      sameAsStart: "End time and Start time cannot be the same",
      afterStartTime: "End time cannot be less than start time",
    },
  },

  description: {
    type: "string",
  },

  requiredDescription: {
    type: "string",
    required: true,
    properties: {
      empty: "Please enter description",
    },
  },

  aka_name: {
    type: "string",
    required: true,
    properties: {
      empty: "Please enter aka name",
    },
  },

  action: {
    type: "string",
    required: true,
    properties: {
      empty: "Please enter action",
    },
  },

  reason: {
    type: "string",
    required: true,
    properties: {
      empty: "Please enter reason",
    },
  },

  status_change_reason: {
    type: "string",
    required: true,
    properties: {
      empty: "Please enter status change reason",
    },
  },

  role: {
    type: "string",
    required: true,
    properties: {
      empty: "Please select role",
    },
  },

  permissions: {
    type: "string",
    required: true,
    properties: {
      empty: "Please select permissions",
    },
  },

  leadId: {
    type: "string",
    required: true,
    properties: {
      empty: "Please select customer",
    },
  },
  customerPhone: {
    type: "string",
    // required: true,
    properties: {
      empty: "Please enter phone number",
      // number: {
      //   msg: "Phone number must be a number",
      // },
      maxLength: {
        limit: 11,
        msg: "Phone number must be 11 digits",
      },
      minLength: {
        limit: 10,
        msg: "Phone number must be 11 digits",
      },
    },
  },
  phoneNumber: {
    type: "string",
    // required: true,
    properties: {
      empty: "Please enter phone number",
      number: {
        msg: "Phone number must be a number",
      },
      maxLength: {
        limit: 11,
        msg: "Phone number must be 11 digits",
      },
      minLength: {
        limit: 10,
        msg: "Phone number must be 11 digits",
      },
    },
  },
  address: {
    type: "string",
    required: true,
    properties: {
      empty: "Please enter address",
    },
  },
  postCode: {
    type: "string",
    required: true,
    properties: {
      empty: "Please enter post code",
      postCode: "Please enter alphanumeric value only",
    },
  },
  transportCode: {
    type: "string",
    required: true,
    properties: {
      empty: "Please enter transport code",
      postCode: "Please enter alphanumeric value only",
    },
  },
  vatPercent: {
    type: "string",
    required: true,
    properties: {
      empty: "Please enter VAT percentage",
      // maxLength: {
      //   limit: 2,
      //   msg: "VAT percentage number must be a number",
      // },
    },
  },
  vat_percent: {
    type: "string",
    required: true,
    properties: {
      empty: "Please enter VAT percentage",
      // maxLength: {
      //   limit: 2,
      //   msg: "VAT percentage number must be a number",
      // },
    },
  },
  vat_reg_no: {
    type: "string",
    required: true,
    properties: {
      empty: "Please enter VAT reg number",
      maxLength: {
        limit: 11,
        msg: "VAT number must be 11 digits",
      },
      alphanumeric: "Please enter alphanumeric value only",
    },
  },

  vatRegNo: {
    type: "string",
    required: true,
    properties: {
      empty: "Please enter VAT reg number",
      maxLength: {
        limit: 11,
        msg: "Phone number must be 11 digits",
      },
      alphanumeric: "Please enter alphanumeric value only",
    },
  },
  dateFormat: {
    type: "string",
    required: true,
    properties: {
      empty: "Please enter date format",
    },
  },

  date: {
    type: "string",
    required: true,
    properties: {
      empty: "Please enter date format",
    },
  },

  adminEmail: {
    type: "email",
    required: true,
    properties: {
      empty: "Please enter email",
      email: "Please enter a valid Email",
    },
  },
  typeId: {
    type: "string",
    required: true,
    properties: {
      empty: "Please select type",
    },
  },
  invoiceAddress: {
    type: "string",
    required: true,
    properties: {
      empty: "Please enter invoice address",
    },
  },
  invoice_address: {
    type: "string",
    required: true,
    properties: {
      empty: "Please enter invoice address",
    },
  },
  paymentTerms: {
    type: "string",
    required: true,
    properties: {
      empty: "Please enter payment terms",
    },
  },
  payment_terms: {
    type: "string",
    required: true,
    properties: {
      empty: "Please enter payment terms",
    },
  },
  // service plan fields
  plan_name: {
    type: "string",
    required: true,
    properties: {
      empty: "Please enter name",
      noLeadingSpace: "Name cannot start with a space",
      atLeastOneAlpha: "At least one alphabet character is required",
    },
  },
  price: {
    type: "number",
    required: true,
    properties: {
      empty: "Please enter price",
      maxNumber: {
        limit: 9999999,
        msg: "price must be be a less than equal to 9999999",
      },
    },
  },
  rate: {
    type: "number",
    required: true,
    properties: {
      empty: "Please enter price",
      maxNumber: {
        limit: 9999999,
        msg: "price must be be a less than equal to 9999999",
      },
    },
  },
  volume: {
    type: "number",
    required: true,
    properties: {
      empty: "Please enter volume",
      maxNumber: {
        limit: 9999999,
        msg: "volume must be be a less than equal to 9999999",
      },
    },
  },
  unit: {
    type: "string",
    required: true,
    properties: {
      empty: "Please select unit",
    },
  },
  duration: {
    type: "string",
    required: true,
    properties: {
      empty: "Please select duration",
    },
  },

  durations: {
    type: "string",
    required: true,
    properties: {
      empty: "Please select durations",
    },
  },

  discount: {
    type: "number",
    required: true,
    properties: {
      empty: "Please enter discount",
      maxNumber: {
        limit: 100,
        msg: "price must be be a less than equal to 100",
      },
    },
  },
  features: {
    type: "string",
    required: true,
    properties: {
      empty: "Please select feature",
    },
  },
  generalWebsite: {
    type: "string",
    properties: {
      websiteLink: "Please enter correct url",
    },
  },
  companyRegNo: {
    type: "string",
    required: true,
    properties: {
      alphanumeric: "Please enter alphanumeric value only",
    },
  },
  extendedLiabilityPercent: {
    type: "number",
    properties: {
      maxNumber: {
        limit: 100,
        msg: "Percentage number must be a less than equal to 100",
      },
    },
  },
  extendedLiabilityTax: {
    type: "number",
    properties: {
      maxNumber: {
        limit: 100,
        msg: "Percentage number must be a less than equal to 100",
      },
    },
  },
  insuranceFixedRate: {
    type: "number",
    properties: {
      maxNumber: {
        limit: 100,
        msg: "Percentage number must be a less than equal to 100",
      },
    },
  },

  // acount setting
  firstName: {
    type: "string",
    required: true,
    properties: {
      empty: "Please enter first name",
    },
  },
  lastName: {
    type: "string",
    required: true,
    properties: {
      empty: "Please enter last name",
    },
  },
  phone: {
    type: "string",
    properties: {
      number: {
        msg: "Phone number must be a number",
      },
      maxLength: {
        limit: 11,
        msg: "Phone number must be 11 digits",
      },
      minLength: {
        limit: 10,
        msg: "Phone number must be 11 digits",
      },
    },
  },

  emergency_contact_number: {
    type: "string",
    properties: {
      number: {
        msg: "Phone number must be a number",
      },
      maxLength: {
        limit: 11,
        msg: "Phone number must be 11 digits",
      },
      minLength: {
        limit: 10,
        msg: "Phone number must be 11 digits",
      },
    },
  },

  mobile: {
    type: "number",
    required: true,
    properties: {
      number: {
        msg: "Phone number must be a number",
      },
      maxLength: {
        limit: 11,
        msg: "Phone number must be 11 digits",
      },
      minLength: {
        limit: 10,
        msg: "Phone number must be 11 digits",
      },
    },
  },

  // storage
  unitTypeName: {
    type: "string",
    required: true,
    properties: {
      empty: "Please enter type name",
    },
  },

   unitTypeId: {
    type: "string",
    required: true,
    properties: {
      empty: "Please select type name",
    },
  },

  storageType: {
    type: "string",
    required: true,
    properties: {
      empty: "Please select storage type",
    },
  },

  rentType: {
    type: "string",
    required: true,
    properties: {
      empty: "Please select rent type",
    },
  },

  sizeFt3: {
    type: "string",
    required: true,
    properties: {
      empty: "Please enter size",
    },
  },

  quantity: {
    type: "string",
    required: true,
    properties: {
      empty: "Please enter quantity",
    },
  },

  unitNumbering: {
    type: "string",
    required: true,
    properties: {
      empty: "Please enter unit numbering",
    },
  },

  prefix: {
    type: "string",
    required: true,
    properties: {
      empty: "Please enter prefix",
    },
  },

  pricePerUnit: {
    type: "string",
    required: true,
    properties: {
      empty: "Please enter price per unit",
    },
  },

  unitWidth: {
    type: "string",
    required: true,
    properties: {
      empty: "Please enter width",
    },
  },

  unitLength: {
    type: "string",
    required: true,
    properties: {
      empty: "Please enter length",
    },
  },

  unitHeight: {
    type: "string",
    required: true,
    properties: {
      empty: "Please enter height",
    },
  },

  monthly_rent: {
    type: "string",
    required: true,
    properties: {
      empty: "Please enter monthly rent",
    },
  },

  siteName: {
    type: "string",
    required: true,
    properties: {
      empty: "Please enter site name",
    },
  },

  siteType: {
    type: "string",
    required: true,
    properties: {
      empty: "Please select site type",
    },
  }
};
